var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.state === "created"
      ? _c("span", { staticClass: "created mr-1" }, [_vm._v("C")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "scheduled"
      ? _c("span", { staticClass: "created mr-1" }, [_vm._v("S")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "company_assign"
      ? _c("span", { staticClass: "created mr-1" }, [_vm._v("CA")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "blocked"
      ? _c("span", { staticClass: "created blocked mr-1" }, [_vm._v("B")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "completed"
      ? _c("span", { staticClass: "created completed mr-1" }, [_vm._v("C")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "approved"
      ? _c("span", { staticClass: "created completed mr-1" }, [_vm._v("A")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "in_progress"
      ? _c("span", { staticClass: "created progress mr-1" }, [_vm._v("I")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "reopened"
      ? _c("span", { staticClass: "created re-opened mr-1" }, [_vm._v("R")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "pending_approval"
      ? _c("span", { staticClass: "created pending-approval mr-1" }, [
          _vm._v("P")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-572b0197", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-572b0197","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Atoms/TaskStateIcon.vue
// module id = null
// module chunks = 